/**
 * Refreshes the product gallery when variant media groups change.
 * Relies on section HTML already fetched by product-info.js (variantChange pub/sub).
 */
(() => {
  if (typeof subscribe !== 'function' || !window.theme?.PUB_SUB_EVENTS?.variantChange) return;

  const gallerySignature = (gallery) =>
    [...gallery.querySelectorAll('[data-image-id]')]
      .map((el) => el.getAttribute('data-image-id'))
      .join(',');

  const activateMedia = (gallery, variant, sectionId) => {
    const mediaId = variant?.featured_media?.id;
    if (!mediaId || !gallery) return;

    const slide = gallery.querySelector(`[data-image-id="${mediaId}"]`);
    if (!slide) return;

    const fullMediaId = slide.getAttribute('data-media-id') || `${sectionId}-${mediaId}`;
    gallery.dispatchEvent(
      new CustomEvent('theme:media:select', {
        bubbles: true,
        detail: { id: fullMediaId },
      })
    );
  };

  subscribe(theme.PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
    const { html, variant, sectionId } = data || {};
    if (!html || !variant || !sectionId) return;

    const productInfo =
      document.getElementById(`MainProduct--${sectionId}`) ||
      document.querySelector(`product-info[data-section="${sectionId}"]`);
    if (!productInfo) return;

    const currentGallery = productInfo.querySelector('product-images[data-variant-media-gallery]');
    if (!currentGallery) return;

    const newProductInfo =
      html.getElementById?.(`MainProduct--${sectionId}`) ||
      html.querySelector?.(`product-info[data-section="${sectionId}"]`) ||
      html.querySelector?.('product-info');
    const newGallery = newProductInfo?.querySelector('product-images[data-variant-media-gallery]');
    if (!newGallery) return;

    if (gallerySignature(currentGallery) === gallerySignature(newGallery)) {
      activateMedia(currentGallery, variant, sectionId);
      return;
    }

    const replacement = document.importNode(newGallery, true);
    currentGallery.replaceWith(replacement);

    const gallery = productInfo.querySelector('product-images[data-variant-media-gallery]');
    requestAnimationFrame(() => {
      activateMedia(gallery, variant, sectionId);
      document.dispatchEvent(
        new CustomEvent('theme:variant-gallery:updated', {
          detail: { gallery },
        })
      );
    });
  });
})();
